import axios from "axios";

export function getVersion() {
	return new Promise(resolve => {
		axios
			.get("../static/version.json?_=" + Math.random())
			.then(response => {
				if (200 == response.status) {
					resolve(response.data.version);
				}
				resolve("unknown");
			})
			.catch(err => {
				console.error(err);
				resolve("unknown");
			});
	});
}
